export default __webpack_public_path__ + "static/media/logo-white.4425de87.png";